export const staticData_prod = {
    id: 'blyeTfqO0X1ZF4JLIUeV',
    userUUID: '689ee37131d7c6f34182e43a',
    chat_username: 'HOME User',
    user_email: 'emo homeproduser@maybetech.com',
    isGHLUser: false,
    address: "",
    agenct_config: {
        PluginOn: true,
        allow: true,
        plugins: [],
        agent_limit: 100
    },
    agency_id: "67e13b8ce6f157d42d5f930e",
    agentBuilder: null,
    apps: ['AI Social App'],
    assistants: [],
    business_name: "HOME",
    city: "",
    conversationId: "",
    country: "",
    createdAt: "2025-08-14T10:19:24.353Z",
    email: "emo+homeprod@maybetech.com",
    first_name: "",
    isAuto: true,
    is_streaming_Api: true,
    is_support: null,
    last_name: "",
    monthly_token_limit: 0,
    monthly_token_usage: 0,
    nango_connected: false,
    number_of_additional_accounts: 0,
    onboarding: {
        website_url: 'www.home.cc',
        email: 'emo+homeprod@maybetech.com',
        verified: true
    },
    openAgentBuilder: false,
    phone_number: "",
    promptlabels_ids: [],
    selected_assistant_id: null,
    state: "",
    time_zone: "Europe/London",
    type: "free",
    updatedAt: "2025-08-18T10:44:01.534Z",
    userId: "689ee37131d7c6f34182e438",
    zip_code: "",
    __v: 0,
    _id: "689db82c982930215d7da4b1"
};

export const staticDataIframe_prod = {
    id: '7FMjT36O0fpwuL9b0z6y',
    userUUID: '68beb450a0e4da08a4f9f03c',
    chat_username: 'Home Test',
    user_email: 'home@maybetech.com',
    isGHLUser: false,
    address: "",
    agenct_config: { PluginOn: false, plugins: [], agent_limit: 100 },
    agency_id: "6739f1be347a7f5974735cec",
    agentBuilder: null,
    apiKey: "5deeca7f-1290c19a-ebab07a2",
    apps: ['AI Social App'],
    assistants: [],
    business_name: "Maybe*  Homepage",
    city: "",
    configration_type: "all_location",
    conversationId: "",
    country: "",
    createdAt: "2024-07-24T12:36:14.531Z",
    customer_id: "cus_T0Ngn5vv88qcT2",
    default_assistant: "asst_c5hPPeZJvRENgIgtLL7Lxv2W",
    email: "polly+test@maybetech.com",
    first_name: "",
    isAuto: true,
    is_streaming_Api: true,
    is_support: null,
    last_name: "",
    monthly_token_limit: 0,
    monthly_token_usage: 0,
    nango_connected: false,
    number_of_additional_accounts: 0,
    onboarding: { website_url: 'www.maybetech.com', email: 'polly+test@maybetech.com', verified: true },
    openAgentBuilder: false,
    phone_number: "",
    planType: "monthly",
    promptlabels_ids: [],
    selected_assistant_id: null,
    state: "",
    stripe_cst_id: "cus_T0Ngn5vv88qcT2",
    time_zone: "Europe/London",
    type: "free",
    updatedAt: "2025-09-09T09:32:20.744Z",
    userId: "68beb450a0e4da08a4f9f03a",
    userUUID: "68beb450a0e4da08a4f9f03c",
    user_email: "home@maybetech.com",
    zip_code: "",
    __v: 3,
    _id: "66a0f53e2fefaba3e94d602a"
};

export const staticData_dev = {
    id: 'blyeTfqO0X1ZF4JLIUeV',
    userUUID: '689ee37131d7c6f34182e43a',
    chat_username: 'HOME User',
    user_email: 'emo homeproduser@maybetech.com',
    isGHLUser: false,
    address: "",
    agenct_config: {
        PluginOn: true,
        allow: true,
        plugins: [],
        agent_limit: 100
    },
    agency_id: "67e13b8ce6f157d42d5f930e",
    agentBuilder: null,
    apps: ['AI Social App'],
    assistants: [],
    business_name: "HOME",
    city: "",
    conversationId: "",
    country: "",
    createdAt: "2025-08-14T10:19:24.353Z",
    email: "emo+homeprod@maybetech.com",
    first_name: "",
    isAuto: true,
    is_streaming_Api: true,
    is_support: null,
    last_name: "",
    monthly_token_limit: 0,
    monthly_token_usage: 0,
    nango_connected: false,
    number_of_additional_accounts: 0,
    onboarding: {
        website_url: 'www.home.cc',
        email: 'emo+homeprod@maybetech.com',
        verified: true
    },
    openAgentBuilder: false,
    phone_number: "",
    promptlabels_ids: [],
    selected_assistant_id: null,
    state: "",
    time_zone: "Europe/London",
    type: "free",
    updatedAt: "2025-08-18T10:44:01.534Z",
    userId: "689ee37131d7c6f34182e438",
    zip_code: "",
    __v: 0,
    _id: "689db82c982930215d7da4b1"
};

// ...existing code...
export const staticDataIframe_dev = {
    id: 'Bgiio44eTEbQjTQy1e3A',
    userUUID: '68f213784deb09185c37957f',
    chat_username: 'Bilal Dev Testing',
    user_email: 'bilal+account4@levelupmarketplace.com',
    isGHLUser: false,
    UserInfo: {
        userName: 'Bilal Dev Testing',
        email: 'bilal+account4@levelupmarketplace.com',
        _id: '68f213784deb09185c37957f',
        userId: '68f213774deb09185c37957d',
    },
    agenct_config: { PluginOn: false, plugins: [] },
    agency_id: '6739f1be347a7f5974735cec',
    agentBuilder: null,
    assistants: [],
    business_name: 'Dev Testing',
    conversationId: '',
    createdAt: '2025-10-17T10:02:11.746Z',
    customer_id: 'cus_TFfxLV0IUmBv4f',
    email: 'bilal+account4@levelupmarketplace.com',
    isAuto: true,
    is_streaming_Api: true,
    is_support: null,
    monthly_token_limit: 100000,
    monthly_token_usage: 4,
    nango_connected: false,
    number_of_additional_accounts: 0,
    number_of_ai_agents: 0,
    number_of_created_agents: 0,
    number_of_team_member: 0,
    number_of_tokens: 1,
    onboarding: { form: [], email: 'sangeeta.m.raghav@gmail.com', verified: true },
    openAgentBuilder: false,
    phone_number: '',
    planType: 'monthly',
    plan_id: '686fdebfe0e47b378ccaad35',
    promptlabels_ids: [],
    selected_assistant_id: null,
    stripe_cst_id: 'cus_TFfxLV0IUmBv4f',
    team_size: 'less-than-10',
    type: 'free',
    unlimited_ai_agents: true,
    updatedAt: '2025-10-17T10:27:36.412Z',
    useAgent: false,
    userId: '68f213774deb09185c37957d',
    zip_code: '',
    __v: 0,
    _id: '68f214234deb09185c3795a8',
};

export const iframeURL_prod = 'iframe.maybetech.com'
export const iframeURL_dev = "iframe.maybedev.ovh"

